// extracted by mini-css-extract-plugin
export default {"text":"TextArea_text__w-bR1"};